import { useState } from "react";
import UserMenu from "../UserMenu/UserMenu";
import LanguageSelector from "./LanguageSelector";
import TurtleNotifications from "./TurtleNotifications";

import "./Topbar.css";

const Topbar = ({ user }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="topbar">
      {/* ЛЕВАЯ ЧАСТЬ */}
      <div className="topbar__left">
        <div className="topbar__brand">
          <div className="topbar__logo">RC</div>

          <div className="topbar__brand-info">
            <strong>RusChina</strong>
          </div>
        </div>
      </div>

      {/* ПРАВАЯ ЧАСТЬ */}
      <div className="topbar__right">
        <LanguageSelector />

        {/* Черепашка-уведомления */}
        <TurtleNotifications />

        <div className="topbar__divider" />

        <button
          type="button"
          className="topbar__avatar"
          onClick={() => setMenuOpen((previous) => !previous)}
          aria-label="Открыть меню пользователя"
        >
          <img
            src={user?.avatar || "https://i.pravatar.cc/150?img=3"}
            alt="avatar"
          />
        </button>

        <UserMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
      </div>
    </header>
  );
};

export default Topbar;